<template>
  <aside class="queue">
    <slot name="lead" />
    <div class="queueHead">
      <div class="queueHeadTop">
        <slot name="head-start" />
        <span class="eyebrow">{{ eyebrow }}</span>
        <slot name="head-end" />
      </div>
      <slot name="head-aside" />
    </div>
    <slot name="bar" />
    <div class="queueScroll">
      <slot />
    </div>
    <div v-if="$slots.foot" class="queueFoot">
      <slot name="foot" />
    </div>
  </aside>
</template>

<script setup lang="ts">
// The dialer's left rail frame: lead block, header, scrolling body, and a foot
// that stays at the bottom edge whatever the body holds.
defineProps<{ eyebrow: string }>()
</script>

<style scoped>
.queue {
  flex: 1;
  width: 100%;
  display: flex;
  flex-direction: column;
  min-height: 0;
  min-width: 0;
  border-right: 1px solid var(--color-border-subtle);
  background: var(--color-bg-app);
}
/* Controls sit 4px apart; the eyebrow's margins keep it 8px clear of them. */
.queueHead { display: flex; align-items: center; gap: var(--space-1); padding: var(--space-4) var(--space-4) var(--space-3); flex-shrink: 0; }
.queueHeadTop { flex: 1; min-width: 0; display: flex; align-items: center; gap: var(--space-1); }
.eyebrow {
  flex: 1;
  min-width: 0;
  margin: 0 var(--space-1);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-size: var(--fs-xs);
  font-weight: var(--fw-semibold);
  letter-spacing: var(--tracking-wide);
  text-transform: uppercase;
  color: var(--color-text-tertiary);
}
.queueScroll { flex: 1; min-height: 0; overflow-y: auto; padding-bottom: var(--space-5); }
.queueFoot { flex-shrink: 0; display: flex; flex-direction: column; gap: var(--space-2); padding: var(--space-3) var(--space-4); border-top: 1px solid var(--color-border-subtle); }

/* ── ADAPTIVE: the avatar rail. The rail is its own container (`rail`, the page's
   .railWrap): 50px when collapsed, a grid share ≥ ~230px otherwise, so under 120px
   is the avatar rail. RailItem, RailGroupHead and DialerQueueRail query the same. */
@container rail (max-width: 120px) {
  .queueHead { flex-direction: column; padding: var(--space-4) 0 var(--space-2); }
  .eyebrow { display: none; }
  .queueHeadTop { justify-content: center; width: 100%; }
  .queueScroll { padding-left: 0; padding-right: 0; }
  .queueFoot { align-items: center; padding: var(--space-3) 0; }
}
</style>
